/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetailsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetailsQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails.ts";
import { individualPaymentAssociatedCompanyViewModelSchema } from "../individualPaymentAssociatedCompanyViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetailsPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetailsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails200Schema =
  z.lazy(
    () => individualPaymentAssociatedCompanyViewModelSchema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetailsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetails200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAssociatedCompanyDetailsQueryResponse>;
